import { App } from '@/react/client/App'
// import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom'
import '../styles/react_application.sass'
import '../styles/Object/checkbox.scss'
import '../styles/Utility/speech.scss'
import '../styles/Utility/line_clamp.scss'
import ReactModal from 'react-modal'

require.context('../images', true, /\.(png|jpg|jpeg|svg|ico)$/)

// const SENTRY_DSN = (window as any).SENTRY_DSN
// if (SENTRY_DSN) {
//   Sentry.init({
//     dsn: SENTRY_DSN,
//   })
// }

document.addEventListener('DOMContentLoaded', () => {
  ReactModal.setAppElement('#modal')
  ReactDOM.render(
    <App />,
    document.body.appendChild(document.createElement('div'))
  )
})
